define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitApplicationService = void 0;
    class PermitApplicationService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("PermitApplication", httpProtocol, hostName, serviceName, proxyUrl);
        }
        calculateGrazingAuthorityPermitFees(permit) {
            let p = {};
            p.permit = permit;
            return this.post("CalculateGrazingAuthorityPermitFees", p, (json) => {
                return json;
            });
        }
        calculateGrazingAuthorityScheduleFees(feeSchedule, totalGrazingArea, isPermitWithinSrn) {
            let p = {};
            p.feeSchedule = feeSchedule;
            p.totalGrazingArea = totalGrazingArea;
            p.isPermitWithinSrn = isPermitWithinSrn;
            return this.post("CalculateGrazingAuthorityScheduleFees", p, (json) => {
                return json;
            });
        }
        calculateGrazingPermitFees(permit) {
            let p = {};
            p.permit = permit;
            return this.post("CalculateGrazingPermitFees", p, (json) => {
                return json;
            });
        }
        calculateTravelPermitFees(permit) {
            let p = {};
            p.permit = permit;
            return this.post("CalculateTravelPermitFees", p, (json) => {
                return json;
            });
        }
        createGrazingAuthorityPermitApplication(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateGrazingAuthorityPermitApplication", p, (json) => {
                return json;
            });
        }
        createGrazingPermitApplication(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateGrazingPermitApplication", p, (json) => {
                return json;
            });
        }
        createHarvestingPermitApplication(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateHarvestingPermitApplication", p, (json) => {
                return json;
            });
        }
        createPermitAmendment(application, permitId) {
            let p = {};
            p.application = application;
            p.permitId = permitId;
            return this.post("CreatePermitAmendment", p, (json) => {
                return json;
            });
        }
        createTravelPermitApplication(geometry) {
            let p = {};
            p.geometry = geometry.toJSON();
            return this.post("CreateTravelPermitApplication", p, (json) => {
                return json;
            });
        }
        createUnfitStockGrazingPermit(application, ufsStartPoint, ufsTravelDuration, isRouteSplitRequested) {
            let p = {};
            p.application = application;
            p.ufsStartPoint = ufsStartPoint.toJSON();
            p.ufsTravelDuration = ufsTravelDuration;
            p.isRouteSplitRequested = isRouteSplitRequested;
            return this.post("CreateUnfitStockGrazingPermit", p, (json) => {
                return json;
            });
        }
        createUnfitStockTravelPermit(application, ufsStartPoint, ufsTravelDuration, isRouteSplitRequested) {
            let p = {};
            p.application = application;
            p.ufsStartPoint = ufsStartPoint.toJSON();
            p.ufsTravelDuration = ufsTravelDuration;
            p.isRouteSplitRequested = isRouteSplitRequested;
            return this.post("CreateUnfitStockTravelPermit", p, (json) => {
                return json;
            });
        }
        findApplicantsByName(queryCriteria, includeDuplicates) {
            let p = {};
            p.queryCriteria = queryCriteria;
            p.includeDuplicates = includeDuplicates;
            return this.post("FindApplicantsByName", p, (json) => {
                return json;
            });
        }
        generateAggregatedPermitReport(reportParameters) {
            let p = {};
            p.reportParameters = reportParameters;
            return this.post("GenerateAggregatedPermitReport", p, (json) => {
                return json;
            });
        }
        generatePermitReport(permit, permitDocumentType) {
            let p = {};
            p.permit = permit;
            p.permitDocumentType = permitDocumentType;
            return this.post("GeneratePermitReport", p, (json) => {
                return json;
            });
        }
        getAggregatedPermitReport(reportFileId) {
            let p = {};
            p.reportFileId = reportFileId;
            return this.requestFile("GetAggregatedPermitReport", p);
        }
        getPermitReport(documentId) {
            let p = {};
            p.documentId = documentId;
            return this.requestFile("GetPermitReport", p);
        }
        persistPermitApplication(application) {
            let p = {};
            p.application = application;
            return this.post("PersistPermitApplication", p, (json) => {
                return json;
            });
        }
        readPermitApplication(applicationId) {
            let p = {};
            p.applicationId = applicationId;
            return this.post("ReadPermitApplication", p, (json) => {
                return json;
            });
        }
        readPermitApplicationByPermitId(id) {
            let p = {};
            p.id = id;
            return this.post("ReadPermitApplicationByPermitId", p, (json) => {
                return json;
            });
        }
        renewGrazingAuthorityPermits(fiscalYear, lgaCode) {
            let p = {};
            p.fiscalYear = fiscalYear;
            p.lgaCode = lgaCode;
            return this.post("RenewGrazingAuthorityPermits", p, (json) => {
                return json;
            });
        }
        requestTmrPermitApproval(permit) {
            let p = {};
            p.permit = permit;
            return this.post("RequestTmrPermitApproval", p, (json) => {
                return json;
            });
        }
        simulateCreateUnfitStockPermit(application, ufsPermitType, ufsStartPoint, ufsTravelDuration) {
            let p = {};
            p.application = application;
            p.ufsPermitType = ufsPermitType;
            p.ufsStartPoint = ufsStartPoint.toJSON();
            p.ufsTravelDuration = ufsTravelDuration;
            return this.post("SimulateCreateUnfitStockPermit", p, (json) => {
                return json;
            });
        }
        splitTravelRouteByLgaBoundary(route) {
            let p = {};
            p.route = route.toJSON();
            return this.post("SplitTravelRouteByLgaBoundary", p, (json) => {
                return json;
            });
        }
        updatePermitApplicationMetadata(application) {
            let p = {};
            p.application = application;
            return this.post("UpdatePermitApplicationMetadata", p, (json) => {
                return json;
            });
        }
        updatePermitOnGeometryChange(permit) {
            let p = {};
            p.permit = permit;
            return this.post("UpdatePermitOnGeometryChange", p, (json) => {
                return json;
            });
        }
        validatePermit(permit) {
            let p = {};
            p.permit = permit;
            return this.post("ValidatePermit", p, (json) => {
                return json;
            });
        }
        validatePermitApplication(application) {
            let p = {};
            p.application = application;
            return this.post("ValidatePermitApplication", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.PermitApplicationService = PermitApplicationService;
});
